if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(function folicareAmazonReviewProofFallback() {
  var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
  if (!match) return;

  var proofByHandle = {
    'hair-thickening-shampoo': { rating: '4.8', count: '54', label: 'Amazon Verified reviews' },
    'hair-thickening-conditioner': { rating: '4.8', count: '54', label: 'Amazon Verified reviews' },
    'hair-growth-bundle-shampoo-conditioner': { rating: '4.8', count: '54', label: 'Amazon Verified reviews' },
    'thickening-hair-serum': { rating: '4.8', count: '64', label: 'Amazon Verified reviews' },
    'hair-skin-nails-vitamins': { rating: '4.8', count: '60', label: 'Amazon Verified reviews' }
  };

  var proof = proofByHandle[match[1]];
  if (!proof) return;

  function install() {
    if (!document.getElementById('folicare-review-proof-fallback-style')) {
      var style = document.createElement('style');
      style.id = 'folicare-review-proof-fallback-style';
      style.textContent = [
        '.jdgm-preview-badge,',
        '.jdgm-review-widget,',
        '.jdgm-rev-widg,',
        '[id*="judge_me_reviews_review_widget"] { display: none !important; }',
        '.product__amazon-proof { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 8px; margin: 8px 0 2px; color: #251b17; text-decoration: none; font-size: 14px; line-height: 1.35; }',
        '.product__amazon-proof-stars { color: #d2a933; letter-spacing: 0; font-size: 15px; line-height: 1; }',
        '.product__amazon-proof strong { font-weight: 700; }',
        '.product__amazon-proof span:last-child { color: #5d5550; }',
        '.product__amazon-proof:hover span:last-child { color: #390d76; }'
      ].join('');
      document.head.appendChild(style);
    }

    if (!document.querySelector('.product__amazon-proof')) {
      var title = document.querySelector('.product__title');
      if (!title) return;

      var badge = document.createElement('a');
      badge.className = 'product__amazon-proof';
      badge.href = '#fr-title';
      badge.setAttribute('aria-label', proof.rating + ' star Amazon rating from ' + proof.count + ' sourced reviews');

      var star = document.createElement('span');
      star.className = 'product__amazon-proof-stars';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = '\u2605';

      var rating = document.createElement('strong');
      rating.textContent = proof.rating;

      var text = document.createElement('span');
      text.textContent = proof.count + ' ' + proof.label;

      badge.appendChild(star);
      badge.appendChild(rating);
      badge.appendChild(text);
      title.insertAdjacentElement('afterend', badge);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();
